type Props = {
  color?: string;
  height?: number;
  flip?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

/** A cabana-scallop divider strip. Use between sections for a soft transition. */
export default function Scallop({
  color = "var(--c-blush)",
  height = 32,
  flip = false,
  className,
  style,
}: Props) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="100%"
      height={height}
      viewBox="0 0 100 10"
      preserveAspectRatio="none"
      className={className}
      style={{
        display: "block",
        transform: flip ? "scaleY(-1)" : undefined,
        ...style,
      }}
    >
      <path
        d="M0,0 Q5,10 10,0 T20,0 T30,0 T40,0 T50,0 T60,0 T70,0 T80,0 T90,0 T100,0 L100,10 L0,10 Z"
        fill={color}
      />
    </svg>
  );
}
